(function () {
    'use strict';
    var m = angular.module('dao');
    m.service('securityEventsDao', ["http", "securityEventTypes", "securityEventStates", "$q", "feature", "modulesDao", "modulesManager", function (http, securityEventTypes, securityEventStates, $q, feature, modulesDao, modulesManager) {
        var activeSaaSApps = modulesManager.activeSaasApps();
        var availableSaaSes = {
            'office365_emails': 'office365_emails_email',
            'office365_onedrive': 'office365_onedrive_file',
            'office365_sharepoint': 'office365_sharepoint_file',
            'google_mail': 'google_mail_email',
            'google_drive': 'google_file',
            'box': 'box_file',
            'dropbox': 'dropbox_file'
        };
        return {
            list: function () {
                return http.get('/api/v1/security_event').params(securityEventTypes.defaultDaoParams()).params(securityEventStates.defaultDaoParams());
            },
            list_aggregated: function () {
                return http.get('/api/v1/security_event_aggregated').params(securityEventTypes.defaultDaoParams()).params(securityEventStates.defaultDaoParams());
            },
            list_es: function (searchAfter, size) {
                var payload = { size: size || 20 };
                if (searchAfter) {
                    payload.search_after = searchAfter;
                }
                return http.post('/api/v1/security_event').params(securityEventTypes.defaultDaoParams()).params(securityEventStates.defaultDaoParams()).body(payload);
            },
            list_aggregated_es: function (searchAfter, size) {
                // searchAfter is an array of keys which use as pointer to next results. e.g. "search_after": [1463538857, "654323"]
                var payload = { size: size || 50 };
                if (searchAfter) {
                    payload.search_after = searchAfter;
                }
                return http.post('/api/v1/security_event_aggregated').params(securityEventTypes.defaultDaoParams()).params(securityEventStates.defaultDaoParams()).body(payload);
            },
            action: function (eventId, actionId) {
                return http.post('/api/v1/security_event/' + eventId + '/action').body({ actions: [actionId] }).run();
            },
            filterAction: function (actionId, filterParams) {
                return http.post('/api/v1/security_event/action').params(filterParams).body({ actions: [actionId] }).run();
            },
            update: function (eventId, data) {
                return http.put('/api/v1/security_event/' + eventId).body(data).run();
            },
            addException: function (data) {
                return http.post('/api/v1/exception').body(data).run();
            },
            listExceptions: function () {
                return http.get('/api/v1/exception');
            },
            deleteException: function (exceptionId) {
                return http.delete('/api/v1/exception/' + exceptionId).run();
            },
            exceptionTypes: function () {
                return http.get('/api/v1/exception/types');
            },
            shadowItApps: function () {
                return http.get('/api/v1/shadow_it_apps');
            },
            stats: function (period, loadShadowIt) {
                if (feature.disableSecurityEventsStats) {
                    return $q.reject({ status: 404 });
                }
                return http.get('/api/v1/security_events_stats').params({
                    period: period,
                    shadow_it_data: loadShadowIt
                }).params(securityEventTypes.defaultDaoParams()).params(securityEventStates.defaultDaoParams());
            },
            getModuleConfigs: function () {
                if (activeSaaSApps && activeSaaSApps.length) {
                    var retrieveConfigQueue = [];
                    var retrieveSaaSes = [];
                    _(activeSaaSApps).each(function (app) {
                        if (availableSaaSes[app.name]) {
                            retrieveSaaSes.push(availableSaaSes[app.name]);
                            retrieveConfigQueue.push(modulesDao.retrieveConfig(app.name));
                        }
                    });
                    if (retrieveSaaSes.length) {
                        return $q.allSettled(retrieveConfigQueue).then(function (responses) {
                            var retrieveData = {};
                            _(retrieveSaaSes).each(function (saas, idx) {
                                retrieveData[saas] = responses[idx].value.data;
                            });
                            return $q.when(retrieveData);
                        });
                    }
                }
                return $q.when({});
            }
        };
    }]);
}());